<script lang="ts">
  import ClassEditor from '$lib/components/classes/ClassEditor.svelte';
  import type { PageProps } from './$types';
  let { data }: PageProps = $props();
</script>

{#await data.classPromise then clazz}
  <ClassEditor classInfo={clazz} />
{/await}
